var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _activeFetch, _CartDiscount_instances, createAbortController_fn, handleDiscountError_fn, existingDiscounts_fn;
import { Component } from "@theme/component";
import { renderCartSection, trackCartRequest, sectionRenderer } from "@theme/section-renderer";
import { fetchConfig, fetchCartJson, setCartCheckout } from "@theme/utilities";
import { cartPerformance } from "@theme/performance";
import { CartDiscountUpdateEvent, CartErrorEvent } from "@shopify/events";
class CartDiscount extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartDiscount_instances);
    __publicField(this, "requiredRefs", ["cartDiscountError", "cartDiscountErrorDiscountCode", "cartDiscountErrorShipping"]);
    __privateAdd(this, _activeFetch, null);
    __publicField(this, "applyDiscount", async (event) => {
      const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping } = this.refs;
      event.preventDefault();
      event.stopPropagation();
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const discountCode = form.querySelector('input[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== "string") return;
      const discountCodeValue = discountCode.value.trim();
      if (!discountCodeValue) return;
      const existingDiscounts = __privateMethod(this, _CartDiscount_instances, existingDiscounts_fn).call(this);
      if (existingDiscounts.includes(discountCodeValue)) return;
      const abortController = __privateMethod(this, _CartDiscount_instances, createAbortController_fn).call(this);
      if (this.refs.cartDiscountErrorRequest) this.refs.cartDiscountErrorRequest.classList.add("hidden");
      cartDiscountError.classList.add("hidden");
      cartDiscountErrorDiscountCode.classList.add("hidden");
      cartDiscountErrorShipping.classList.add("hidden");
      const allDiscountCodes = [...existingDiscounts, discountCodeValue];
      const deferredPromise = CartDiscountUpdateEvent.createPromise();
      const ticket = trackCartRequest(deferredPromise.promise);
      this.dispatchEvent(
        new CartDiscountUpdateEvent({
          discountCodes: allDiscountCodes.map((code) => ({ code })),
          promise: deferredPromise.promise
        })
      );
      let checkoutState = "failed";
      try {
        const config = fetchConfig("json", {
          body: JSON.stringify({
            discount: allDiscountCodes.join(","),
            sections: [this.dataset.sectionId],
            sections_url: window.location.pathname
          })
        });
        const data = await fetchCartJson(Theme.routes.cart_update_url, config, abortController);
        if (abortController.signal.aborted) {
          const cancelled = new Error("Cart request cancelled");
          cancelled.name = "AbortError";
          throw cancelled;
        }
        if (!data || !Array.isArray(data.items) || !Array.isArray(data.discount_codes)) throw new Error("Invalid cart response");
        deferredPromise.resolve({ cart: CartDiscountUpdateEvent.createCartFromAjaxResponse(data) });
        if (data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })) {
          checkoutState = null;
          discountCode.value = "";
          __privateMethod(this, _CartDiscount_instances, handleDiscountError_fn).call(this, "discount_code");
          return;
        }
        const { html: newHtml, section } = await this.getDiscountSection(data, abortController);
        if (abortController.signal.aborted || __privateGet(this, _activeFetch) !== abortController) return;
        const discountCodes = (section == null ? void 0 : section.querySelectorAll(".cart-discount__pill")) || [];
        if (section) {
          const codes = Array.from(discountCodes).map((element) => element instanceof HTMLLIElement ? element.dataset.discountCode : null).filter(Boolean);
          if (codes.length === existingDiscounts.length && codes.every((code) => existingDiscounts.includes(code)) && data.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === true;
          })) {
            checkoutState = null;
            __privateMethod(this, _CartDiscount_instances, handleDiscountError_fn).call(this, "shipping");
            discountCode.value = "";
            return;
          }
        }
        await renderCartSection(this.dataset.sectionId, newHtml, { mode: this.closest("theme-drawer") ? "hydration" : "full", signal: abortController.signal }, ticket);
        checkoutState = null;
        if (__privateGet(this, _activeFetch) === abortController && discountCode.value.trim() === discountCodeValue) {
          discountCode.value = "";
        }
      } catch (error) {
        deferredPromise.reject(error);
        if (error instanceof Error && error.name !== "AbortError" && __privateGet(this, _activeFetch) === abortController) {
          if (this.refs.cartDiscountErrorRequest) {
            this.refs.cartDiscountError.classList.remove("hidden");
            this.refs.cartDiscountErrorDiscountCode.classList.add("hidden");
            this.refs.cartDiscountErrorShipping.classList.add("hidden");
            this.refs.cartDiscountErrorRequest.classList.remove("hidden");
          }
          this.dispatchEvent(
            new CartErrorEvent({
              error: error.message || "Failed to apply discount",
              code: "SERVICE_UNAVAILABLE"
            })
          );
        }
      } finally {
        if (__privateGet(this, _activeFetch) === abortController) {
          __privateSet(this, _activeFetch, null);
          setCartCheckout(this, checkoutState);
        }
        cartPerformance.measureFromEvent("discount-update:user-action", event);
      }
    });
    __publicField(this, "removeDiscount", async (event) => {
      const activation = event instanceof KeyboardEvent ? event.key === "Enter" || event.key === " " : event instanceof MouseEvent;
      if (!activation || !(event.target instanceof HTMLElement) || typeof this.dataset.sectionId !== "string") return;
      event.preventDefault();
      event.stopPropagation();
      const pill = event.target.closest(".cart-discount__pill");
      if (!(pill instanceof HTMLLIElement)) return;
      const discountCode = pill.dataset.discountCode;
      if (!discountCode) return;
      const existingDiscounts = __privateMethod(this, _CartDiscount_instances, existingDiscounts_fn).call(this);
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;
      existingDiscounts.splice(index, 1);
      this.refs.cartDiscountError.classList.add("hidden");
      if (this.refs.cartDiscountErrorRequest) this.refs.cartDiscountErrorRequest.classList.add("hidden");
      const abortController = __privateMethod(this, _CartDiscount_instances, createAbortController_fn).call(this);
      const deferredPromise = CartDiscountUpdateEvent.createPromise();
      const ticket = trackCartRequest(deferredPromise.promise);
      this.dispatchEvent(
        new CartDiscountUpdateEvent({
          discountCodes: existingDiscounts.map((code) => ({ code })),
          promise: deferredPromise.promise
        })
      );
      let checkoutState = "failed";
      try {
        const config = fetchConfig("json", {
          body: JSON.stringify({ discount: existingDiscounts.join(","), sections: [this.dataset.sectionId], sections_url: window.location.pathname })
        });
        const data = await fetchCartJson(Theme.routes.cart_update_url, config, abortController);
        if (abortController.signal.aborted) {
          const cancelled = new Error("Cart request cancelled");
          cancelled.name = "AbortError";
          throw cancelled;
        }
        if (!data || !Array.isArray(data.items) || !Array.isArray(data.discount_codes)) throw new Error("Invalid cart response");
        deferredPromise.resolve({
          cart: CartDiscountUpdateEvent.createCartFromAjaxResponse(data)
        });
        const { html } = await this.getDiscountSection(data, abortController);
        if (abortController.signal.aborted || __privateGet(this, _activeFetch) !== abortController) return;
        await renderCartSection(this.dataset.sectionId, html, {
          mode: this.closest("theme-drawer") ? "hydration" : "full",
          signal: abortController.signal
        }, ticket);
        checkoutState = null;
      } catch (error) {
        deferredPromise.reject(error);
        if (error instanceof Error && error.name !== "AbortError" && __privateGet(this, _activeFetch) === abortController) {
          if (this.refs.cartDiscountErrorRequest) {
            this.refs.cartDiscountError.classList.remove("hidden");
            this.refs.cartDiscountErrorDiscountCode.classList.add("hidden");
            this.refs.cartDiscountErrorShipping.classList.add("hidden");
            this.refs.cartDiscountErrorRequest.classList.remove("hidden");
          }
          this.dispatchEvent(
            new CartErrorEvent({
              error: error.message || "Failed to remove discount",
              code: "SERVICE_UNAVAILABLE"
            })
          );
        }
      } finally {
        if (__privateGet(this, _activeFetch) === abortController) {
          __privateSet(this, _activeFetch, null);
          setCartCheckout(this, checkoutState);
        }
      }
    });
  }
  /** Read a missing section without replaying the already confirmed cart mutation. */
  async getDiscountSection(data, controller) {
    const assertCurrent = () => {
      if (controller.signal.aborted || __privateGet(this, _activeFetch) !== controller) {
        const cancelled = new Error("Cart request cancelled");
        cancelled.name = "AbortError";
        throw cancelled;
      }
    };
    assertCurrent();
    const findSection = (html2) => typeof html2 === "string" && html2.trim() ? new DOMParser().parseFromString(html2, "text/html").getElementById("shopify-section-".concat(this.dataset.sectionId)) : null;
    let html = data.sections && data.sections[this.dataset.sectionId];
    let section = findSection(html);
    if (!section) {
      html = await sectionRenderer.getSectionHTML(this.dataset.sectionId, false, new URL(window.location.href), controller.signal);
      assertCurrent();
      section = findSection(html);
    }
    if (!section) throw new Error("Cart section missing from response");
    return { html, section };
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const active = __privateGet(this, _activeFetch);
    if (active) active.abort();
    __privateSet(this, _activeFetch, null);
    setCartCheckout(this, null);
  }
}
_activeFetch = /* @__PURE__ */ new WeakMap();
_CartDiscount_instances = /* @__PURE__ */ new WeakSet();
createAbortController_fn = function() {
  if (__privateGet(this, _activeFetch)) {
    __privateGet(this, _activeFetch).abort();
  }
  const abortController = new AbortController();
  __privateSet(this, _activeFetch, abortController);
  setCartCheckout(this, "pending");
  return abortController;
};
handleDiscountError_fn = function(type) {
  const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping } = this.refs;
  const target = type === "discount_code" ? cartDiscountErrorDiscountCode : cartDiscountErrorShipping;
  cartDiscountError.classList.remove("hidden");
  target.classList.remove("hidden");
  const errorMessage = type === "discount_code" ? "Invalid discount code" : "Discount not applicable for shipping";
  this.dispatchEvent(
    new CartErrorEvent({
      error: errorMessage,
      code: "VALIDATION_CUSTOM"
    })
  );
};
existingDiscounts_fn = function() {
  const discountCodes = [];
  const discountPills = this.querySelectorAll(".cart-discount__pill");
  for (const pill of discountPills) {
    if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === "string") {
      discountCodes.push(pill.dataset.discountCode);
    }
  }
  return discountCodes;
};
if (!customElements.get("cart-discount-component")) {
  customElements.define("cart-discount-component", CartDiscount);
}
